import request from "@/plugin/axios"

export function getUserPermissionInfo() {
  return request({
    url: "/admin/baseUser/v2/front/info",
    method: "get"
  })
}
